/** Secciones del Módulo 0 (teoría). Cada clave tiene .title y .body en es/en. */
export const THEORY_SECTIONS = [
  'theory.seat',
  'theory.mirrors',
  'theory.dashboard',
  'theory.prnd',
  'theory.pedals',
  'theory.creep',
  'theory.msm',
  'theory.signals',
  'theory.steering',
  'theory.lane',
  'theory.braking',
  'theory.stopLine',
  'theory.stopSign',
  'theory.speed',
  'theory.distance',
  'theory.reverse',
  'theory.reverseCam',
  'theory.priorities',
] as const;

/** Teoría específica del cambio MANUAL: embrague, caja en H, cuestas… */
export const THEORY_MANUAL_SECTIONS = [
  'theory.clutch',
  'theory.bitepoint',
  'theory.hpattern',
  'theory.stalling',
  'theory.moveoff',
  'theory.stopManual',
  'theory.upshift',
  'theory.downshift',
  'theory.revmatch',
  'theory.hillstart',
  'theory.handbrakeM',
  'theory.ecoShift',
] as const;
